<template>
  <div class="markdown-stream-node">
    <streaming-markdown :content="chunks" :streaming="status === 'streaming'" />
    <slot />
  </div>
</template>

<script>
import StreamingMarkdown from '@/components/basic/streaming-markdown/StreamingMarkdown.vue';

export default {
  name: 'MarkdownStreamNode',
  components: {
    StreamingMarkdown,
  },
  props: {
    nodeId: String,
    chunks: { type: Array, default: () => [] },
    status: { type: String, default: 'streaming' },
    editMode: Boolean,
  },
};
</script>

<style lang="less">
// Additional node-specific styles can go here if needed
// Base streaming markdown styles come from the StreamingMarkdown component
</style>
